// @flow

import type {
  GATEWAY_TYPE,
} from './gateways';
import type { ERROR_TYPE } from './common';

export type GATEWAY_USER_ACTION_TYPE = {
  id: number,
  gateway: GATEWAY_TYPE,
  schedule: {
    id: number,
    week_days: Array<number>
  },
  action: string,
  gateway_user: number,
};


export type GATEWAY_USER_ACTION_FETCH_SUCCESS_TYPE = {
  type: 'GATEWAY_USER_ACTION_FETCH_SUCCESS',
  payload: {
    entities: {[number]: GATEWAY_USER_ACTION_TYPE},
    order: Array<number>,
  }
};
export const GATEWAY_USER_ACTION_FETCH_SUCCESS = 'GATEWAY_USER_ACTION_FETCH_SUCCESS';


export type GATEWAYS_USER_ACTION_FETCH_FAILED_TYPE = {
  type: 'GATEWAYS_USER_ACTION_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const GATEWAYS_USER_ACTION_FETCH_FAILED = 'GATEWAYS_USER_ACTION_FETCH_FAILED';


export type GATEWAYS_ACTION_TYPE =
  GATEWAY_USER_ACTION_FETCH_SUCCESS_TYPE
  | GATEWAYS_USER_ACTION_FETCH_FAILED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/gatewayUserActions.js